import { isPresent } from '@apl-digital/utils';
import { formatDistance } from 'date-fns';

function _extends() {
    _extends = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

const nullAsJson = JSON.stringify(null);
const maybeArrayToArray = (maybeArray, defaultValue)=>{
    if (Array.isArray(maybeArray)) {
        if (maybeArray.length === 0) {
            return defaultValue;
        }
        return maybeArray;
    }
    return isPresent(maybeArray) ? [
        maybeArray
    ] : defaultValue;
};

class ZodStorage {
    constructor(schemas, storage, logger){
        this.schemas = schemas;
        this.logger = logger;
        this.clearStorage = (key, options)=>{
            var _this_logger;
            const storageKeys = isPresent(options) && options.includeUnmanaged ? Object.keys(this.storage) : Object.keys(this.storage).filter((k)=>k in this.schemas);
            const actualKeys = maybeArrayToArray(key, storageKeys);
            if (isPresent(options)) {
                if (options.mode === 'keep') {
                    var _this_logger1;
                    (_this_logger1 = this.logger) == null ? void 0 : _this_logger1.info(`[${this.name}] Clearing all keys except: ${actualKeys.join(', ')}`);
                    storageKeys.forEach((k)=>{
                        if (!actualKeys.includes(k)) {
                            this.storage.removeItem(k);
                        }
                    });
                    return;
                } else if (options.mode === 'remove') {
                    var _this_logger2;
                    (_this_logger2 = this.logger) == null ? void 0 : _this_logger2.info(`[${this.name}] Clearing keys: ${actualKeys.join(', ')}`);
                    storageKeys.forEach((currentStoragekey)=>{
                        if (actualKeys.includes(currentStoragekey)) {
                            this.storage.removeItem(currentStoragekey);
                        }
                    });
                    return;
                }
            }
            (_this_logger = this.logger) == null ? void 0 : _this_logger.info(`[${this.name}] Clearing keys: ${actualKeys.join(', ')}`);
            for (const k of actualKeys){
                this.storage.removeItem(String(k));
            }
        };
        this.setStorage = (key, value, options)=>{
            let container = {
                type: 'simple',
                value: value
            };
            if ((options == null ? void 0 : options.type) === 'expiringRecord') {
                var _this_logger;
                container = _extends({}, container, {
                    type: 'expiringRecord',
                    expiresAt: options.expiresAt,
                    createdAt: options.createdAt || Date.now()
                });
                (_this_logger = this.logger) == null ? void 0 : _this_logger.info(`[${this.name}] ${String(key)} is expiring in ${formatDistance(container.createdAt, container.expiresAt)}`);
            }
            this.storage.setItem(String(key), JSON.stringify(container));
        };
        this.getStorage = (key, defaultValue)=>{
            const value = this.storage.getItem(String(key));
            if (isPresent(value) && value !== nullAsJson && value) {
                try {
                    const parsedData = JSON.parse(value);
                    const validatedData = this.schemas[key].parse(parsedData.value);
                    if (parsedData.type === 'expiringRecord') {
                        if (parsedData.expiresAt < Date.now()) {
                            var _this_logger;
                            (_this_logger = this.logger) == null ? void 0 : _this_logger.info(`[${this.name}] key ${String(key)} has expired, resetting value...`);
                            this.clearStorage(key);
                            return defaultValue === undefined ? null : defaultValue;
                        }
                    }
                    return validatedData;
                } catch (error) {
                    var _this_logger1, _this_logger2;
                    (_this_logger1 = this.logger) == null ? void 0 : _this_logger1.warn(`[${this.name}] Error while parsing storage key ${String(key)}, resetting value...`);
                    (_this_logger2 = this.logger) == null ? void 0 : _this_logger2.error(error);
                    this.clearStorage(key);
                }
            }
            if (defaultValue === undefined) {
                return null;
            }
            return defaultValue;
        };
        if ('name' in storage) {
            this.name = storage.name;
            this.storage = storage.storage;
        } else {
            this.name = 'Storage';
            this.storage = storage;
        }
    }
}

export { ZodStorage };
